import { employeeReduxConstants } from '@/constants';
import { NormalizedEmployee } from '@/types/employee';

export type EmployeesState = {
  ids: Array<number>;
  all: {
    [id: number]: NormalizedEmployee;
  };
};

export function employees(
  state: EmployeesState = { ids: [], all: {} },
  action: { type: string; employees?: EmployeesState },
): EmployeesState {
  switch (action.type) {
    case employeeReduxConstants.SET_EMPLOYEES:
      return {
        ids: [...state.ids, ...action.employees.ids],
        all: {
          ...state.all,
          ...action.employees.all,
        },
      };

    default:
      return state;
  }
}
